import React from 'react';

import './styles.scss';
import { APP_TEXTS } from '@texts';

export default props => (
  <React.Fragment>
    {props.show && (
      <div className="confirmation-popup">
        <div className="confirmation-popup__content">
          <h4>{APP_TEXTS.LABEL_CONFIRMATION_DISCARD_CHANGES.Content}</h4>

          <div className="control-group">
            <button className="btn btn-danger" onClick={props.confirm}>
              {APP_TEXTS.LABEL_CONFIRM.Content}
            </button>
            <button className="btn btn-dark" onClick={props.cancel}>
              {APP_TEXTS.BUTTONS_CANCEL.Content}
            </button>
          </div>
        </div>
      </div>
    )}
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Editor/Anchors/Confirmation/index.js